import { Injectable } from '@angular/core';
import { FiraBreakdownModel } from 'src/app/types/FiraBreakdown';
import { Profile } from 'src/app/types/Profile';
import { PayoutFeesResponse } from 'src/app/types/responses/PayoutFeesResponse';
import { UnsubscribeOptions } from 'src/app/types/UnsubscribeOptions';
import { Business } from '../../../types/Business';
import { PaymentMethodDetails } from '../../../types/PaymentDetails';
import { CoreService } from '../../core.service';
import { SharedProfileData } from '../../data/shared-profile-data';
import { IPublicService } from '../IPublicService';
import { OpenApiService } from '../open-api.service';
import { mockPayoutFeesList, mockProfile } from './mock-data';

@Injectable({
  providedIn: 'root',
})
export class MockPublicService implements IPublicService {
  private profile: Profile = { ...mockProfile };

  private payoutFeesList: PayoutFeesResponse[] = mockPayoutFeesList;

  private mockFIRABreakDownResponse: FiraBreakdownModel = {
    id: 'd0fb6b6b-723b-4e99-8ac6-f64fcc65906d',
    bankName: 'IDFC Bank',
    chargedAmount: 738.03,
    chargedAmountCurrency: 'INR',
    midMarketRate: 86.53,
    transactionDate: 'Sep 05, 2024',
    purposeCode: 'P1104',
    usdAmount: 2607.71,
    userFxRate: 83.75,
    inrAfterFx: 218395.72,
    fxSpread: 0.83,
    effectiveTotalCost: 738.03,
    chargedPaise: 0.83,
    chargeBps: 95.61,
    effectiveFxSpreadInInr: 2.78, // 86.53 - 83.75
    effectiveTotalCostCalc: 0.83 * 2607.71, // 2165.40
  };

  constructor(
    private sharedProfileData: SharedProfileData,
    private openApiService: OpenApiService,
    private _coreService: CoreService,
  ) {}

  async getGenericFees(
    sellCurrency: string,
    buyCurrency: string,
  ): Promise<{
    conversionRate: number;
    validUpto: string;
    midMarketRate: number;
  }> {
    // return Promise.resolve(this.payoutFeesList[0].conversionAgainstOneUnit ?? 0);
    const midMarketRate = this.payoutFeesList[0].conversionAgainstOneUnit ?? 0;
    const userConversionRate = midMarketRate - midMarketRate * 0.01;
    return {
      conversionRate: userConversionRate,
      validUpto: 'Apr 3, 2025, 10:44 IST',
      midMarketRate: midMarketRate,
    };
  }

  async getUserUnsubscribeStatus(hash: string): Promise<boolean> {
    if (hash === 'test') {
      return this._coreService.delayResolve(true);
    }
    return this._coreService.delayResolve(false);
  }

  async unsubscribeEmailNotification(
    hash: string,
    reason: UnsubscribeOptions,
    feedback: string,
  ): Promise<boolean> {
    return this._coreService.delayResolve(true);
  }

  async generateBankDetailsPDF(
    beneficiaryName: String,
    clientDetails: Partial<Business>,
    selectedBankDetails: PaymentMethodDetails[],
    currency?: string,
  ): Promise<Blob> {
    return this._coreService.delayResolve(new Blob());
  }

  async saveContactUsFormSubmission(
    name: string,
    email: string,
    phone: string,
    message: string,
  ): Promise<boolean> {
    return this._coreService.delayResolve(true);
  }

  async getFIRABreakDown(firaFile: File): Promise<{
    success: boolean;
    data: FiraBreakdownModel;
    error: string;
  }> {
    return this._coreService.delayResolve({
      success: true,
      data: this.mockFIRABreakDownResponse,
      error: '',
    });
  }

  async getFIRABreakDownById(requestId: String): Promise<{
    success: boolean;
    data: FiraBreakdownModel | null;
    error: string;
  }> {
    return this._coreService.delayResolve({
      success: true,
      data: this.mockFIRABreakDownResponse,
      error: '',
    });
  }
}
